import React from 'react';
import { Title as Title$1, Text } from '@10d/tend-ui-typography';
import { Box } from '@10d/tend-ui-grid';
import { Button } from '../Button/Button.js';
import { Error } from './components/Error/Error.js';
import { New } from './components/New/New.js';
import { Filter } from './components/Filter/Filter.js';
import { Circle, Root as Root$1 } from './styled.js';

const Root = ({ children }) => {
    return (React.createElement(Root$1, { "data-testid": 'tend-ui-empty', className: 'tend-ui-empty-root' }, children));
};
Root.displayName = 'Empty.Root';
const Title = ({ children }) => {
    return (React.createElement(Title$1, { level: 'h6', margin: 0 }, children));
};
Title.displayName = 'Empty.Title';
const Description = ({ children }) => {
    return React.createElement(Text, null, children);
};
Description.displayName = 'Empty.Description';
const Empty = ({ size = 'medium', variant = 'empty', title, description, buttons, }) => {
    const Image = { empty: New, ['no-results']: Filter, error: Error }[variant];
    return (React.createElement(Root, null,
        React.createElement(Box, { className: 'tend-ui-empty-header' },
            React.createElement(Circle, { "$size": { large: 200, medium: 96, small: 56 }[size] },
                React.createElement(Image, { size: { large: 100, medium: 48, small: 28 }[size] }))),
        (title || description) && (React.createElement(Box, { "$display": 'flex', "$flexDirection": 'column', "$alignItems": 'center', className: 'tend-ui-empty-body' },
            title && React.createElement(Title, null, title),
            description && React.createElement(Description, null, description))),
        buttons && (React.createElement(Box, { className: 'tend-ui-empty-footer', "$display": 'flex', "$gap": 8 }, buttons.map((button, index) => {
            var _a;
            return (React.createElement(Button, Object.assign({ key: (_a = button.key) !== null && _a !== void 0 ? _a : index }, button)));
        })))));
};
Empty.displayName = 'Empty';

export { Empty };
